export default function resolveUrl(relativeUrl) {
    const appBasePath = (window.app?.basePath ?? '').replace(/^\//, '');
    relativeUrl = relativeUrl.replace(window.location.origin, '');

    if (relativeUrl.indexOf('~') === 0)
        relativeUrl = relativeUrl.substring(1);

    if (relativeUrl.indexOf('/') === 0)
        relativeUrl = relativeUrl.substring(1);

    return window.location.origin + '/' + appBasePath + relativeUrl;
}
